import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { css as r } from '../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = r`:host .generic-carousel-container:before{display:block}@media (max-width:767px){:host .header{margin-top:24px}}@media (min-width:1024px){:host .swiper{margin:0 auto;padding:0 2px}}:host .swiper-wrapper{padding:2px 0 8px}:host ::slotted([slot=cta]){display:flex}@media (max-width:767px){:host ::slotted([slot=cta]){margin-top:24px!important}}`;

export { css_248z as default };
